import React from 'react'
import { Button } from './styles'

const ReturnButton = ({ label, onClick }) => (
    <Button onClick={onClick}>{label}</Button>
)

export default ReturnButton